import ChevronDown from "@/assets/icons/chevron-down.svg";
import ChevronUp from "@/assets/icons/chevron-up.svg";
import TextButton from "@components/TextButton";

const ExpandMentions: React.FunctionComponent<{
  showFullDescription: boolean;
  onClick: () => void;
}> = ({ showFullDescription, onClick }) => {
  return (
    <TextButton
      data-testid="show-full-description-button"
      iconPlacement="after"
      onClick={onClick}
      icon={showFullDescription ? ChevronUp : ChevronDown}
    >
      {showFullDescription
        ? L.MENTIONS_SHOW_SHORT_EPISODE_DESCRIPTION
        : L.MENTIONS_SHOW_FULL_EPISODE_DESCRIPTION}
    </TextButton>
  );
};

export default ExpandMentions;
